(() => {
  'use strict';
  const KEY = 'leshemsNativeFilteringInitialized';
  if (window[KEY]) return;
  window[KEY] = true;
  if (document.body?.dataset.nativeIsolation === 'true' || new URLSearchParams(window.location.search).get('leshems_qa') === 'metrics') {
    const record = () => {
      const entries = performance.getEntriesByType('resource').filter(entry => ['fetch', 'xmlhttprequest', 'script'].includes(entry.initiatorType));
      document.body.dataset.nativeNetwork = JSON.stringify(entries.slice(-150).map(entry => ({ url: entry.name, type: entry.initiatorType, ms: Math.round(entry.duration), bytes: entry.transferSize })));
      const navigation = performance.getEntriesByType('navigation')[0];
      if (navigation) document.body.dataset.nativeNavigation = JSON.stringify({ ttfb: Math.round(navigation.responseStart - navigation.requestStart), responseEnd: Math.round(navigation.responseEnd), domContentLoaded: Math.round(navigation.domContentLoadedEventEnd), load: Math.round(navigation.loadEventEnd), bytes: navigation.transferSize });
    };
    new PerformanceObserver(record).observe({ entryTypes: ['resource'] });
    window.addEventListener('load', record); document.addEventListener('leshems:native-filters-updated', record);
    record();
  }
  const ROOT = '[data-leshems-native-root]';
  const FORM = '[data-leshems-native-form]';
  const SEARCH_FORM = '[data-native-search-form]';
  const STONE_PARAM = 'filter.p.m.custom.filter_stone_types';
  const SELECTION_PARAM = 'leshems_selection';
  const CLIENT_VERSION = 'focused-2026-10-24';
  let activeRequest = null;
  let requestSequence = 0;
  let debounceId = null;
  let scrollLock = null;
  let inertEntries = [];
  let loadObserver = null;
  let scrollFrame = null;
  let restoringHistory = false;
  const visitedResults = new Map();
  function positionKey() {
    const url = new URL(window.location.href);
    url.searchParams.delete('preview_theme_id');
    if (url.searchParams.get('sort_by') === 'created-descending') url.searchParams.delete('sort_by');
    url.searchParams.sort();
    return 'leshemsNativePosition:' + url.pathname + url.search;
  }
  function storedPosition() {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(positionKey()) || 'null');
      return value && Date.now() - value.savedAt < 1800000 ? value : null;
    } catch { return null; }
  }
  const initialHistory = window.history.state?.leshemsNativeFilter ? window.history.state : storedPosition();
  let snapshotRoot = null;
  let snapshotRevision = null;
  let scrollTimer = null;
  const pageInfo = root => root?.querySelector('[data-native-page-info]');
  function rememberResults() {
    const root = locate();
    if (!root || restoringHistory || root.dataset.nativeRequestState === 'pending') return;
    const previous = visitedResults.get(window.location.href);
    const revision = root.dataset.nativeUpdateSequence + ':' + pageInfo(root)?.dataset.page;
    const html = previous && snapshotRoot === root && snapshotRevision === revision ? previous.html : root.outerHTML;
    snapshotRoot = root;
    snapshotRevision = revision;
    const value = { html, scrollY: window.scrollY };
    visitedResults.delete(window.location.href);
    visitedResults.set(window.location.href, value);
    while (visitedResults.size > 6) visitedResults.delete(visitedResults.keys().next().value);
    window.history.replaceState({ ...window.history.state, leshemsNativeFilter: true, scrollY: window.scrollY,
      loadedThrough: Number(pageInfo(root)?.dataset.page || 1), startPage: Number(new URL(window.location.href).searchParams.get('page') || 1) }, '', window.location.href);
    try { window.sessionStorage.setItem(positionKey(), JSON.stringify({ ...window.history.state, savedAt: Date.now() })); } catch {}
  }
  async function restoreLoadedPages(saved) {
    if (!saved?.loadedThrough || !pageInfo(locate())) return;
    const scrollY = saved.scrollY || 0;
    restoringHistory = true;
    try {
      while (Number(pageInfo(locate())?.dataset.page || 1) < saved.loadedThrough) {
        const root = locate();
        const next = root.querySelector('[data-native-next]');
        if (!next) break;
        const before = Number(pageInfo(root).dataset.page);
        await navigate(new URL(next.href), { append: true });
        if (Number(pageInfo(locate())?.dataset.page) <= before) break;
      }
    } finally {
      restoringHistory = false;
      rememberResults();
      restoreScrollPosition(scrollY);
    }
  }
  function restoreScrollPosition(y) {
    let cancelled = false;
    const cancel = () => { cancelled = true; };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, cancel, { once: true, passive: true }));
    const restore = () => { if (!cancelled) window.scrollTo(0, Math.max(0, Number(y) || 0)); };
    window.requestAnimationFrame(() => window.requestAnimationFrame(restore));
    [100, 350, 800].forEach(ms => window.setTimeout(restore, ms));
    window.setTimeout(() => {
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.removeEventListener(type, cancel));
      rememberResults(); observeNextPage();
    }, 850);
  }
  function observeNextPage() {
    loadObserver?.disconnect();
    const root = locate();
    if (!root || root.dataset.nativeValidation !== 'ready' || !('IntersectionObserver' in window)) return;
    const next = root.querySelector('[data-native-next]');
    if (!next) return;
    loadObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting) || activeRequest || restoringHistory) return;
      loadObserver.disconnect();
      navigate(new URL(next.href), { append: true });
    }, { rootMargin: '0px 0px 250px 0px' });
    loadObserver.observe(next);
  }
  window.addEventListener('scroll', () => {
    if (scrollTimer) return;
    scrollTimer = window.setTimeout(() => { scrollTimer = null; rememberResults(); }, 200);
  }, { passive: true });
  window.addEventListener('pagehide', rememberResults);
  window.addEventListener('pageshow', () => { observeNextPage(); });
  const mobile = window.matchMedia('(max-width:749px)');
  const locate = () => document.querySelector(ROOT);
  if (locate()) locate().dataset.nativeClient = CLIENT_VERSION;
  const isManagedFilter = name => name.startsWith('filter.') && !name.startsWith('filter.v.price.');
  // The DEV header enters the owned native page even when another installed
  // search handler cancels the ordinary anchor action.
  window.addEventListener('click', event => {
    const anchor = event.target.closest?.('a.leshems-native-search-link');
    if (!anchor || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(anchor.href, window.location.href);
    if (target.origin !== window.location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    target.searchParams.delete('view');
    window.location.assign(previewSafeTarget(target).href);
  }, true);
  function supportedFilters(root) {
    try {
      const values = JSON.parse(root?.dataset.nativeSupportedFilters || 'null');
      return Array.isArray(values) ? values : null;
    } catch { return null; }
  }
  function stoneIntent(query) {
    const key = String(query || '').normalize('NFKC').trim().toLowerCase();
    if (['amethyst', 'amethist', 'amethiyst', 'אמטיסט'].includes(key)) return ['Amethyst'];
    if (['ruby', 'rubies', 'רובי'].includes(key)) return ['Ruby'];
    if (['garnet', 'garnets', 'גארנט', 'גרנט'].includes(key)) return ['Garnet'];
    if (['emerald', 'emeralds', 'אמרלד'].includes(key)) return ['Emerald'];
    return null;
  }
  function searchIntent(query) {
    const key = String(query || '').normalize('NFKC').trim().toLowerCase().replace(/[–—-]/g, ' ').replace(/\s+/g, ' ');
    if (!key || key.length > 512) return null;
    const fields = [
      [STONE_PARAM, [
        ['Amethyst', 'amethyst|amethist|amethiyst|אמטיסט'], ['Ruby', 'ruby|rubies|רובי'],
        ['Garnet', 'garnet|garnets|גארנט|גרנט'], ['Emerald', 'emerald|emeralds|אמרלד'],
        ['Sapphire', 'sapphire|sapphires|ספיר'], ['Aquamarine', 'aquamarine|אקוומרין'],
        ['Diamond', 'diamond|diamonds|יהלום|יהלומים'], ['Spinel', 'spinel|ספינל'],
        ['Topaz', 'topaz|טופז'], ['Tourmaline', 'tourmaline|טורמלין'],
        ['Morganite', 'morganite|מורגנייט'], ['Citrine', 'citrine|סיטרין'],
        ['Tanzanite', 'tanzanite|טנזנייט'], ['Peridot', 'peridot|פרידוט'],
        ['Tsavorite', 'tsavorite|צבורייט'], ['Iolite', 'iolite|איולייט'],
        ['Jade', 'jade|ג׳ייד'], ['Lapis Lazuli', 'lapis lazuli|לפיס לזולי'], ['No Stones', 'no stones|ללא אבנים']
      ]],
      ['filter.p.m.custom.filter_jewelry_type', [
        ['Ring', 'ring|rings|טבעת|טבעות'], ['Pendant', 'pendant|pendants|תליון|תליוני|תליונים'],
        ['Earrings', 'earring|earrings|עגיל|עגילי|עגילים'], ['Bracelet', 'bracelet|bracelets|צמיד|צמידי|צמידים'],
        ['Necklace', 'necklace|necklaces|שרשרת|שרשראות']
      ]],
      ['filter.p.m.custom.filter_metals', [
        ['White Gold', 'white gold|זהב לבן|בזהב לבן'], ['Yellow Gold', 'yellow gold|זהב צהוב|בזהב צהוב'],
        ['Rose Gold', 'rose gold|pink gold|זהב ורוד|בזהב ורוד|רוז גולד'], ['Platinum', 'platinum|פלטינה|בפלטינה']
      ]],
      ['filter.p.m.custom.filter_shapes', [['Emerald Cut', 'emerald cut|ליטוש אמרלד|אמרלד קאט']]],
      ['filter.p.m.custom.filter_availability', [
        ['In Stock', 'in stock|במלאי'], ['Made to Order', 'made to order|לפי הזמנה'],
        ['Within 7 business days', 'within 7 business days|תוך 7 ימי עסקים'],
        ['Within 10 business days', 'within 10 business days|תוך 10 ימי עסקים'],
        ['Within 14 business days', 'within 14 business days|תוך 14 ימי עסקים'],
        ['Within 21 business days', 'within 21 business days|תוך 21 ימי עסקים']
      ]]
    ];
    const aliases = fields.flatMap(([name, entries]) => entries.flatMap(([value, labels]) => labels.split('|').map(label => ({ name, value, words: label.split(' ') })))).sort((a, b) => b.words.length - a.words.length);
    const words = key.split(' ');
    const intent = {};
    let previous = null;
    let connector = null;
    for (let i = 0; i < words.length;) {
      if (['or', 'או', 'and', 'וגם'].includes(words[i])) {
        if (!previous || connector || i === words.length - 1) return null;
        connector = ['or', 'או'].includes(words[i]) ? 'OR' : 'AND';
        i++;
        continue;
      }
      const match = aliases.find(alias => alias.words.every((word, offset) => words[i + offset] === word));
      if (!match && ['in', 'with', 'ב', 'עם'].includes(words[i])) {
        if (!previous || connector || i === words.length - 1) return null;
        connector = 'AND';
        i++;
        continue;
      }
      if (!match) return null;
      if (connector === 'OR' && previous !== match.name) return null;
      if (intent[match.name] && connector !== 'OR') return null;
      if (!intent[match.name]) intent[match.name] = [];
      if (!intent[match.name].includes(match.value)) intent[match.name].push(match.value);
      previous = match.name;
      connector = null;
      i += match.words.length;
    }
    return Object.keys(intent).length ? intent : null;
  }
  function normalizeLegacyTarget(target) {
    const aliases = {
      'stone-type': 'filter_stone_types', 'jewelry-type': 'filter_jewelry_type',
      metal: 'filter_metals', 'stone-shape': 'filter_shapes', style: 'filter_styles',
      'setting-style': 'filter_setting_styles', availability: 'filter_availability',
      'center-type': 'filter_center_stone_type', 'center-shape': 'filter_center_stone_shape'
    };
    const seed = target.searchParams.get('leshems_stone');
    if (['Sapphire', 'Emerald', 'Ruby', 'Aquamarine', 'Garnet'].includes(seed)) {
      const values = target.searchParams.getAll('filter.stone-type');
      if (!values.includes(seed)) target.searchParams.append('filter.stone-type', seed);
    }
    Object.entries(aliases).forEach(([alias, field]) => {
      const legacy = 'filter.' + alias;
      const values = target.searchParams.getAll(legacy);
      if (!values.length) return;
      const canonical = 'filter.p.m.custom.' + field;
      const existing = target.searchParams.getAll(canonical).flatMap(value => value.split(','));
      if (existing.length && (values.some(value => !existing.includes(value)) || existing.some(value => !values.includes(value)))) return;
      if (!existing.length) [...new Set(values)].forEach(value => target.searchParams.append(canonical, value));
      target.searchParams.delete(legacy);
    });
    if (seed && !target.searchParams.has('filter.stone-type') && target.searchParams.getAll(STONE_PARAM).includes(seed)) target.searchParams.delete('leshems_stone');
    return target;
  }
  function normalizeSearchTarget(target, root) {
    const query = target.searchParams.get('q');
    const intent = searchIntent(query);
    const supported = supportedFilters(root);
    if (intent) {
      if (!Object.keys(intent).every(name => supported?.includes(name))) return target;
      target.searchParams.set('q', '*');
      target.searchParams.set('leshems_query', query.trim());
      if (intent[STONE_PARAM]) target.searchParams.delete('filter.p.m.custom.stone_profiles');
      Object.entries(intent).forEach(([name, values]) => {
        target.searchParams.delete(name);
        values.forEach(value => target.searchParams.append(name, value));
      });
      target.searchParams.delete('page');
    }
    // Exact stone intent uses Shopify's complete collection index. Keep free-text
    // requests in search; never synthesize or cache a product set in the client.
    if (target.searchParams.get('q') === '*' && ((target.searchParams.has(STONE_PARAM) && supported?.includes(STONE_PARAM)) || Object.keys(searchIntent(target.searchParams.get('leshems_query')) || {}).length > 0) && supported && root?.dataset.nativeCanonicalSearchUrl && root?.dataset.nativeSearchUrl) {
      const searchPath = new URL(root.dataset.nativeSearchUrl, window.location.href).pathname;
      const catalog = new URL(root.dataset.nativeCanonicalSearchUrl, window.location.href);
      if (catalog.origin === target.origin && target.pathname === searchPath) {
        target.pathname = catalog.pathname;
        if (root.dataset.nativeView) target.searchParams.set('view', root.dataset.nativeView);
        else if (root.dataset.nativeRenderSection === 'leshems-native-search-results') target.searchParams.set('view', 'leshems-native-search-24');
        else target.searchParams.delete('view');
        if (target.searchParams.get('sort_by') === 'relevance') target.searchParams.delete('sort_by');
      }
    }
    return target;
  }
  function configureRoot(root, target) {
    const supported = supportedFilters(root);
    const unsupported = supported && [...target.searchParams.keys()].filter(name => isManagedFilter(name) && !supported.includes(name));
    const unavailablePrice = supported && [...target.searchParams.keys()].some(name => name.startsWith('filter.v.price.')) && !supported.includes('filter.v.price');
    const intent = searchIntent(target.searchParams.get('q'));
    const unavailableSearch = supported && intent && Object.keys(intent).some(name => !supported.includes(name));
    const invalidValues = root.dataset.nativeVerifyValues === 'true' && [...new Set(target.searchParams.keys())].some(name => {
      if (!isManagedFilter(name) || !supported?.includes(name)) return false;
      const rendered = [...root.querySelectorAll('input[type=checkbox]')].filter(input => input.name === name).map(input => input.value);
      return target.searchParams.getAll(name).flatMap(value => value.split(',')).some(value => !rendered.includes(value));
    });
    const selectedSort = target.searchParams.get('sort_by');
    const sortOptions = [...root.querySelectorAll('select[name="sort_by"] option')].map(option => option.value);
    const invalidSort = Boolean(selectedSort && sortOptions.length && !sortOptions.includes(selectedSort));
    const blocked = Boolean(unsupported?.length || unavailablePrice || unavailableSearch || invalidValues || invalidSort);
    const pending = Boolean(intent && supported && Object.keys(intent).every(name => supported.includes(name)));
    root.dataset.nativeValidation = blocked ? 'blocked' : pending ? 'pending' : 'ready';
    const warning = root.querySelector('[data-native-filter-unavailable]');
    if (warning) warning.hidden = !blocked;
    root.querySelectorAll('.leshems-native-pilot__grid,.leshems-native-pilot__pagination,[data-native-result-count],[data-native-empty]').forEach(element => { element.hidden = blocked || pending; });
    const input = root.querySelector('[data-native-query]');
    if (input && target.searchParams.get('q') === '*') {
      const original = target.searchParams.get('leshems_query');
      if (searchIntent(original)) input.value = original;
      if (searchIntent(original)) root.querySelectorAll('[data-native-all-content]').forEach(anchor => { const url = new URL(anchor.href, window.location.href); url.searchParams.set('q', original); anchor.href = url.href; });
    }
    const status = root.querySelector('[data-leshems-native-status]');
    if (blocked && status) status.textContent = warning?.textContent.trim() || '';
    if (root.dataset.nativePageTitle) document.title = blocked ? (warning?.textContent.trim() || root.dataset.nativePageTitle) : root.dataset.nativePageTitle;
    return !blocked && !pending;
  }
  function previewSafeTarget(target) {
    const safe = new URL(target.href);
    if (!safe.searchParams.has('preview_theme_id')) return safe;
    const supported = supportedFilters(locate()) || [];
    const repeated = {};
    for (const name of new Set(safe.searchParams.keys())) {
      const values = safe.searchParams.getAll(name);
      if (isManagedFilter(name) && supported.includes(name) && values.length > 1) repeated[name] = values;
    }
    if (Object.keys(repeated).length) safe.searchParams.set(SELECTION_PARAM, JSON.stringify(repeated));
    else safe.searchParams.delete(SELECTION_PARAM);
    return safe;
  }
  function inheritPreview(url) {
    const here = new URL(window.location.href);
    const root = locate();
    ['view', 'preview_theme_id'].forEach(key => {
      if (!url.searchParams.has(key) && here.searchParams.has(key)) url.searchParams.set(key, here.searchParams.get(key));
    });
    if (!url.searchParams.has('view') && root?.dataset.nativeView) url.searchParams.set('view', root.dataset.nativeView);
    if (!url.searchParams.has('preview_theme_id') && root?.dataset.nativeThemeId) url.searchParams.set('preview_theme_id', root.dataset.nativeThemeId);
    for (const key of here.searchParams.keys()) {
      if ((key.startsWith('utm_') || ['gclid', 'fbclid', 'msclkid'].includes(key)) && !url.searchParams.has(key)) {
        url.searchParams.set(key, here.searchParams.get(key));
      }
    }
    return url;
  }
  function urlForForm(form) {
    const url = inheritPreview(new URL(window.location.href));
    url.searchParams.delete('leshems_stone');
    url.searchParams.delete('page');
    const names = new Set([...(supportedFilters(form.closest(ROOT)) || []).filter(isManagedFilter), ...[...form.elements].filter(el => el.name && isManagedFilter(el.name)).map(el => el.name)]);
    names.forEach(name => url.searchParams.delete(name));
    url.searchParams.delete('sort_by');
    const data = new FormData(form);
    for (const [name, value] of data.entries()) {
      if (isManagedFilter(name)) url.searchParams.append(name, String(value));
      else if ((name === 'sort_by' || name === 'q' || name === 'type' || name === 'view') && String(value)) {
        if (name !== 'sort_by' || !String(value).startsWith('price-')) url.searchParams.set(name, String(value));
      }
    }
    const intent = searchIntent(url.searchParams.get('leshems_query'));
    if (intent && !Object.entries(intent).every(([name, values]) => {
      const selected = url.searchParams.getAll(name);
      return selected.length === values.length && values.every(value => selected.includes(value));
    })) url.searchParams.delete('leshems_query');
    return url;
  }
  function syncCategoryLinks() {
    if (!locate()) return;
    const current = new URL(window.location.href);
    document.querySelectorAll('a[data-native-category-base]').forEach(anchor => {
      const target = new URL(anchor.href, current);
      if (target.origin !== current.origin || !target.pathname.includes('/collections/')) return;
      const original = new URL(anchor.dataset.nativeCategoryBase, current);
      for (const name of new Set(target.searchParams.keys())) {
        if (name.startsWith('filter.') && !original.searchParams.has(name)) target.searchParams.delete(name);
      }
      for (const name of new Set(current.searchParams.keys())) {
        if ((isManagedFilter(name) || name.startsWith('filter.v.price.')) && !original.searchParams.has(name)) {
          target.searchParams.delete(name);
          current.searchParams.getAll(name).forEach(value => target.searchParams.append(name, value));
        }
      }
      target.searchParams.delete('page');
      if (!original.searchParams.has('sort_by')) {
        target.searchParams.delete('sort_by');
        const sort = current.searchParams.get('sort_by');
        if (sort && !sort.startsWith('price-')) target.searchParams.set('sort_by', sort);
      }
      const categoryTarget = inheritPreview(target);
      if (categoryTarget.pathname !== current.pathname && /^leshems-native-search-(12|24|48)$/.test(categoryTarget.searchParams.get('view') || '')) categoryTarget.searchParams.set('view', categoryTarget.searchParams.get('view').replace('native-search-', 'native-'));
      anchor.href = previewSafeTarget(categoryTarget).href;
    });
  }
  function syncLocalizationReturn() {
    if (!locate()) return;
    const url = new URL(window.location.href);
    ['preview_theme_id', 'section_id', 'sections'].forEach(key => url.searchParams.delete(key));
    url.searchParams.delete(SELECTION_PARAM);
    const supported = supportedFilters(locate()) || [];
    const repeated = {};
    for (const name of new Set(url.searchParams.keys())) {
      const values = url.searchParams.getAll(name);
      if (isManagedFilter(name) && supported.includes(name) && values.length > 1) repeated[name] = values;
    }
    // Localization/preview redirects can collapse repeated query keys. Keep an
    // explicit copy and restore real native facets after the localized page loads.
    if (Object.keys(repeated).length) url.searchParams.set(SELECTION_PARAM, JSON.stringify(repeated));
    for (const form of document.querySelectorAll('form[action]')) {
      const action = new URL(form.action, url);
      if (action.origin !== url.origin || !action.pathname.endsWith('/localization')) continue;
      const input = form.querySelector('input[name="return_to"]');
      if (input) input.value = url.pathname + url.search;
    }
  }
  function restoreLocalizationSelections(target, root) {
    const raw = target.searchParams.get(SELECTION_PARAM);
    target.searchParams.delete(SELECTION_PARAM);
    if (!raw || raw.length > 20000) return false;
    try {
      const selections = JSON.parse(raw);
      if (!selections || Array.isArray(selections) || typeof selections !== 'object') return false;
      const entries = Object.entries(selections);
      const supported = supportedFilters(root) || [];
      if (!entries.length || entries.length > 25 || entries.reduce((n, [, values]) => n + (Array.isArray(values) ? values.length : 101), 0) > 100) return false;
      if (!entries.every(([name, values]) => isManagedFilter(name) && supported.includes(name) && Array.isArray(values) && values.length > 1 && values.every(value => typeof value === 'string' && value.length > 0 && value.length <= 512))) return false;
      entries.forEach(([name, values]) => {
        target.searchParams.delete(name);
        values.forEach(value => target.searchParams.append(name, value));
      });
      return true;
    } catch { return false; }
  }
  function updateBusy(root, busy) {
    root.setAttribute('aria-busy', String(busy));
    root.classList.toggle('leshems-native-is-loading', busy);
    const status = root.querySelector('[data-leshems-native-status]');
    if (status) status.textContent = busy ? (root.dataset.loadingLabel || 'Updating results') : '';
  }
  function focusDrawerWhenReady(target, root, panel) {
    if (!target || !panel) return;
    const restore = () => {
      if (locate() !== root || !root.classList.contains('leshems-native-drawer-open')) return;
      if (panel.contains(document.activeElement)) return;
      target.focus({ preventScroll: true });
    };
    restore();
    window.requestAnimationFrame(restore);
    window.setTimeout(restore, 250);
  }
  function setDrawer(open, focus) {
    const root = locate();
    if (!root) return;
    open = Boolean(open) && mobile.matches;
    inertEntries.forEach(({ element, wasInert }) => { element.inert = wasInert; });
    inertEntries = [];
    root.classList.toggle('leshems-native-drawer-open', open);
    const panel = root.querySelector(FORM);
    if (open && panel) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      const heading = panel.querySelector('.leshems-native-pilot__mobilehead strong');
      if (heading?.id) panel.setAttribute('aria-labelledby', heading.id);
      if (!scrollLock) scrollLock = { overflow: document.body.style.overflow };
      document.body.style.overflow = 'hidden';
      let branch = panel;
      while (branch.parentElement) {
        [...branch.parentElement.children].forEach(element => {
          if (element === branch || element.matches('script,style,link,[data-native-drawer-close]')) return;
          inertEntries.push({ element, wasInert: element.inert });
          element.inert = true;
        });
        if (branch.parentElement === document.body) break;
        branch = branch.parentElement;
      }
    } else {
      panel?.removeAttribute('role');
      panel?.removeAttribute('aria-modal');
      panel?.removeAttribute('aria-labelledby');
      if (scrollLock) { document.body.style.overflow = scrollLock.overflow; scrollLock = null; }
    }
    const opener = root.querySelector('[data-native-drawer-open]');
    if (opener) opener.setAttribute('aria-expanded', String(Boolean(open)));
    if (focus) {
      const target = open ? root.querySelector('.leshems-native-pilot__mobileclose') : opener;
      if (open) focusDrawerWhenReady(target, root, panel);
      else if (target) target.focus({ preventScroll: true });
    }
  }
  async function navigate(target, behavior = {}) {
    if (target.origin !== window.location.origin) return;
    target = normalizeLegacyTarget(inheritPreview(target));
    // The locale handoff has already restored native query keys. Its temporary
    // copy must never survive an edit, reset or history traversal.
    target.searchParams.delete(SELECTION_PARAM);
    if ((target.searchParams.get('sort_by') || '').startsWith('price-')) target.searchParams.delete('sort_by');
    const root = locate();
    if (!root) return;
    if (!behavior.append && !behavior.popstate) rememberResults();
    loadObserver?.disconnect();
    const sectionId = root.dataset.nativeSectionId;
    let renderSection = root.dataset.nativeRenderSection || sectionId;
    if (root.dataset.nativeCanonicalSearchUrl && root.dataset.nativeSearchUrl) {
      const catalogPath = new URL(root.dataset.nativeCanonicalSearchUrl, window.location.href).pathname;
      const searchPath = new URL(root.dataset.nativeSearchUrl, window.location.href).pathname;
      if (target.pathname === catalogPath && root.dataset.nativeRenderSection !== 'leshems-native-results') renderSection = root.dataset.nativeRenderSection === 'leshems-native-search-results' ? 'leshems-native-results' : 'leshems-native-filter-lab';
      else if (target.pathname === searchPath) renderSection = root.dataset.nativeRenderSection === 'leshems-native-search-results' ? 'leshems-native-search-results' : 'leshems-native-search-lab';
    }
    const htmlResponse = root.dataset.nativeRenderMode === 'html';
    if (!sectionId) { window.location.assign(previewSafeTarget(target).href); return; }
    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();
    const controller = activeRequest;
    const sequence = ++requestSequence;
    const form = root.querySelector(FORM);
    const active = document.activeElement;
    const focusName = active && form && form.contains(active) && active.name ? active.name : null;
    const focusValue = active && active.value ? active.value : null;
    const focusId = active?.id || null;
    const moreOpen = Boolean(root.querySelector('[data-native-more]')?.open);
    const openGroups = new Map([...root.querySelectorAll('details[data-native-filter-param]')].map(group => [group.dataset.nativeFilterParam, group.open]));
    const requestUrl = new URL(target.href);
    requestUrl.searchParams.delete('sections');
    requestUrl.searchParams.delete('section_id');
    requestUrl.searchParams.set(htmlResponse ? 'section_id' : 'sections', renderSection);
    // The initial preview page has already established Shopify's DEV preview cookie.
    // Re-sending preview_theme_id can redirect the Sections API away from its JSON response.
    requestUrl.searchParams.delete('preview_theme_id');
    root.dataset.nativeLastRequest = requestUrl.pathname + requestUrl.search;
    root.dataset.nativeRequestState = 'pending';
    let timedOut = false;
    const timeout = window.setTimeout(() => { timedOut = true; controller.abort(); }, 15000);
    updateBusy(root, true);
    try {
      const response = await fetch(requestUrl.href, {
        signal: controller.signal, credentials: 'same-origin',
        headers: { Accept: htmlResponse ? 'text/html' : 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Sections request returned ' + response.status);
      const sections = htmlResponse ? null : await response.json();
      const html = htmlResponse ? await response.text() : sections && sections[renderSection];
      if (typeof html !== 'string' || !html.trim()) throw new Error('Missing section HTML');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextRoot = doc.querySelector(ROOT);
      if (!nextRoot || (root.dataset.nativeRenderSection ? nextRoot.dataset.nativeRenderSection !== renderSection : nextRoot.dataset.nativeSectionId !== sectionId)) throw new Error('Unexpected section response');
      if (root.dataset.nativeThemeId && nextRoot.dataset.nativeThemeId !== root.dataset.nativeThemeId) throw new Error('Unexpected preview theme');
      if (sequence !== requestSequence || controller.signal.aborted) return;
      // Honor drawer changes made while the request was in flight.
      const openBefore = root.classList.contains('leshems-native-drawer-open');
      if (behavior.append) {
        root.querySelector('[data-native-load-error]')?.remove();
        if (!configureRoot(nextRoot, target)) throw new Error('Invalid next-page results');
        const currentPage = Number(pageInfo(root)?.dataset.page || 1);
        if (Number(pageInfo(nextRoot)?.dataset.page) !== currentPage + 1 || nextRoot.dataset.nativePageSize !== root.dataset.nativePageSize) throw new Error('Unexpected next page');
        const grid = root.querySelector('.leshems-native-pilot__grid');
        const nextGrid = nextRoot.querySelector('.leshems-native-pilot__grid');
        if (!grid || !nextGrid) throw new Error('Missing next-page products');
        const seen = new Set([...grid.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
        const incoming = [...nextGrid.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId);
        if (incoming.some(id => seen.has(id)) || new Set(incoming).size !== incoming.length) throw new Error('Duplicate next-page products');
        grid.append(...nextGrid.childNodes);
        const pagination = root.querySelector('.leshems-native-pilot__pagination');
        const nextPagination = nextRoot.querySelector('.leshems-native-pilot__pagination');
        if (pagination && nextPagination) pagination.replaceWith(nextPagination);
        else pagination?.remove();
        pageInfo(root).dataset.page = pageInfo(nextRoot).dataset.page;
        root.dataset.nativeRequestState = 'complete';
        root.dataset.nativeUpdateSequence = String(sequence);
        updateBusy(root, false);
        rememberResults();
        document.dispatchEvent(new CustomEvent('leshems:native-filters-updated', { detail: { url: window.location.href, appended: true } }));
        return;
      }
      root.replaceWith(nextRoot);
      nextRoot.querySelectorAll('details[data-native-filter-param]').forEach(group => {
        group.open = openGroups.get(group.dataset.nativeFilterParam) || false;
      });
      const nextMore = nextRoot.querySelector('[data-native-more]');
      if (nextMore) nextMore.open = moreOpen;
      nextRoot.dataset.nativeUpdateSequence = String(sequence);
      nextRoot.dataset.nativeClient = CLIENT_VERSION;
      nextRoot.dataset.nativeLastRequest = requestUrl.pathname + requestUrl.search;
      nextRoot.dataset.nativeRequestState = 'complete';
      const publicTarget = previewSafeTarget(target);
      if (!behavior.popstate || publicTarget.href !== window.location.href) window.history[behavior.popstate || behavior.replace ? 'replaceState' : 'pushState']({ leshemsNativeFilter: true }, '', publicTarget.pathname + publicTarget.search + publicTarget.hash);
      updateBusy(nextRoot, false);
      const valid = configureRoot(nextRoot, target);
      const normalized = normalizeSearchTarget(new URL(target.href), nextRoot);
      if (normalized.href !== target.href) {
        navigate(normalized, { ...behavior, replace: true });
        return;
      }
      syncCategoryLinks();
      syncLocalizationReturn();
      setDrawer(openBefore && !behavior.closeDrawer, false);
      if (behavior.moveFocus) {
        const count = nextRoot.querySelector(valid ? '[data-native-result-count]' : '[data-native-filter-unavailable]');
        if (count) { count.focus({ preventScroll: true }); count.scrollIntoView({ block: 'start' }); }
      } else {
        let target = focusId ? [...nextRoot.querySelectorAll('[id]')].find(element => element.id === focusId) : null;
        // Facet order can change with the result set; prefer the stored parameter and value.
        if (focusName) target = [...nextRoot.querySelectorAll('input[name],select[name]')].find(el => el.name === focusName && (el.tagName === 'SELECT' || focusValue === null || el.value === focusValue));
        if (target && !target.disabled && target.getClientRects().length) {
          const panel = nextRoot.querySelector(FORM);
          if (openBefore && !behavior.closeDrawer && panel?.contains(target)) focusDrawerWhenReady(target, nextRoot, panel);
          else target.focus({ preventScroll: true });
        } else if (openBefore && !behavior.closeDrawer) focusDrawerWhenReady(nextRoot.querySelector('.leshems-native-pilot__mobileclose'), nextRoot, nextRoot.querySelector(FORM));
        else if (focusName || focusId) nextRoot.querySelector('[data-native-result-count]')?.focus({ preventScroll: true });
      }
      const status = nextRoot.querySelector('[data-leshems-native-status]');
      if (status && valid) status.textContent = nextRoot.querySelector('[data-native-result-count]')?.textContent.trim() || '';
      rememberResults();
      document.dispatchEvent(new CustomEvent('leshems:native-filters-updated', { detail: { url: target.href } }));
    } catch (error) {
      if ((!timedOut && controller.signal.aborted) || sequence !== requestSequence) return;
      updateBusy(root, false);
      root.dataset.nativeRequestState = 'fallback';
      root.dataset.nativeRequestError = String(error.message || error).slice(0, 180);
      console.warn('[LESHEMS Native Filters] Section update failed:', root.dataset.nativeRequestError);
      const status = root.querySelector('[data-leshems-native-status]');
      if (status) status.textContent = root.dataset.errorLabel || 'Loading the page';
      if (behavior.append) {
        let errorMessage = root.querySelector('[data-native-load-error]');
        if (!errorMessage) {
          errorMessage = document.createElement('p'); errorMessage.dataset.nativeLoadError = ''; errorMessage.setAttribute('role', 'alert');
          root.querySelector('.leshems-native-pilot__pagination')?.prepend(errorMessage);
        }
        errorMessage.textContent = root.dataset.loadMoreErrorLabel || root.dataset.errorLabel || '';
      } else window.location.assign(previewSafeTarget(target).href);
    } finally {
      window.clearTimeout(timeout);
      if (sequence === requestSequence) { activeRequest = null; if (locate()?.dataset.nativeRequestState !== 'fallback') observeNextPage(); }
    }
  }
  function schedule(form) {
    loadObserver?.disconnect();
    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
      requestSequence++;
    }
    window.clearTimeout(debounceId);
    debounceId = window.setTimeout(() => navigate(urlForForm(form)), 125);
  }
  document.addEventListener('change', event => {
    const form = event.target.closest ? event.target.closest(FORM) : null;
    if (!form || !form.closest(ROOT)) return;
    if (!event.target.matches('input[type="checkbox"],select[name="sort_by"],select[data-native-page-size-select]')) return;
    schedule(form);
  });
  let suggestionTimer = null;
  let suggestionController = null;
  let suggestionSequence = 0;
  const suggestionCache = new Map();
  function closeSuggestions(input) {
    const panel = input?.closest(SEARCH_FORM)?.querySelector('[data-native-suggestions]');
    if (panel) panel.hidden = true;
    input?.setAttribute('aria-expanded', 'false');
    input?.removeAttribute('aria-activedescendant');
  }
  function cancelSuggestions(input) {
    window.clearTimeout(suggestionTimer);
    suggestionController?.abort(); suggestionSequence++;
    closeSuggestions(input);
    const message = input?.closest(SEARCH_FORM)?.querySelector('[data-native-suggestion-message]');
    if (message) message.remove();
  }
  function showSuggestions(input, html) {
    if (!input.isConnected || document.activeElement !== input) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const entries = [...doc.querySelectorAll('[data-native-suggestion-results] a[data-product-id]')];
    const form = input.closest(SEARCH_FORM);
    let panel = form.querySelector('[data-native-suggestions]');
    if (!panel) {
      panel = document.createElement('div'); panel.className = 'leshems-native-suggestions'; panel.dataset.nativeSuggestions = '';
      panel.id = input.id + '-suggestions';
      form.append(panel);
    }
    panel.replaceChildren();
    if (!entries.length) { closeSuggestions(input); return; }
    const list = document.createElement('ul'); list.setAttribute('role', 'listbox');
    list.id = panel.id + '-list'; list.setAttribute('aria-label', input.dataset.suggestionsLabel || input.getAttribute('aria-label') || input.name);
    entries.slice(0, 6).forEach((entry, index) => {
      const target = new URL(entry.getAttribute('href'), window.location.href);
      if (target.origin !== window.location.origin || !target.pathname.includes('/products/')) return;
      const li = document.createElement('li'); li.setAttribute('role', 'presentation');
      const a = document.createElement('a'); a.href = inheritPreview(target).href; a.textContent = entry.textContent.trim();
      a.id = list.id + '-' + index; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
      li.append(a); list.append(li);
    });
    const close = document.createElement('button'); close.type = 'button'; close.textContent = input.dataset.closeLabel || '×';
    close.addEventListener('click', () => { cancelSuggestions(input); input.focus(); });
    panel.append(list, close); panel.hidden = !list.children.length;
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', list.id); input.setAttribute('aria-expanded', String(!panel.hidden));
  }
  function requestSuggestions(input) {
    cancelSuggestions(input);
    const query = input.value.trim();
    if (query.length < 2 || query.length > 128) return;
    const sequence = suggestionSequence;
    const hebrew = document.documentElement.lang.toLowerCase().startsWith('he');
    const url = new URL(input.closest(ROOT).dataset.nativeSearchUrl + (hebrew ? '' : '/suggest'), window.location.origin);
    if (hebrew) { url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last'); }
    url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '6'); url.searchParams.set('resources[options][fields]', 'title,product_type,tag,variants.title');
    url.searchParams.set('section_id', 'leshems-native-suggestions');
    const qa = new URLSearchParams(window.location.search);
    if (input.closest(ROOT).dataset.nativeThemeId === '161481949269' && qa.get('leshems_qa') === 'metrics' && qa.get('leshems_qa_suggestions') === 'fail') url.searchParams.set('resources[type]', 'qa-invalid-resource');
    inheritPreview(url);
    url.searchParams.delete('preview_theme_id');
    url.searchParams.delete('view');
    suggestionTimer = window.setTimeout(async () => {
      if (suggestionCache.has(url.href)) { showSuggestions(input, suggestionCache.get(url.href)); return; }
      const controller = new AbortController(); suggestionController = controller;
      const started = performance.now();
      let timedOut = false;
      input.dataset.suggestionState = 'pending';
      input.dataset.suggestionBudget = '5000';
      const timeout = window.setTimeout(() => { timedOut = true; controller.abort(); }, 5000);
      try {
        const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        input.dataset.suggestionHttpStatus = String(response.status);
        if (!response.ok) throw new Error('Suggestions unavailable');
        const html = await response.text();
        if (sequence !== suggestionSequence || !input.isConnected || input.value.trim() !== query) return;
        if (controller.signal.aborted) throw new Error('Suggestions timed out');
        if (!html.includes('data-native-suggestion-results')) throw new Error('Unexpected suggestions');
        suggestionCache.set(url.href, html);
        while (suggestionCache.size > 12) suggestionCache.delete(suggestionCache.keys().next().value);
        input.dataset.suggestionState = 'complete';
        showSuggestions(input, html);
      } catch {
        if (sequence === suggestionSequence) {
          closeSuggestions(input);
          input.dataset.suggestionState = timedOut ? 'timeout' : 'error';
          const form = input.closest(SEARCH_FORM);
          if (form && input.isConnected) {
            const message = document.createElement('p'); message.dataset.nativeSuggestionMessage = ''; message.setAttribute('role', 'status');
            message.textContent = input.dataset.suggestionsErrorLabel || '';
            form.append(message);
          }
        }
      }
      finally { input.dataset.suggestionElapsedMs = String(Math.round(performance.now() - started)); window.clearTimeout(timeout); }
    }, 180);
  }
  function suggestionKey(input, event) {
    const panel = input.closest(SEARCH_FORM)?.querySelector('[data-native-suggestions]:not([hidden])');
    if (event.key === 'Escape') { event.preventDefault(); cancelSuggestions(input); return; }
    if (!panel) return;
    const options = [...panel.querySelectorAll('[role="option"]')];
    const selected = options.findIndex(option => option.getAttribute('aria-selected') === 'true');
    if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
      event.preventDefault();
      const index = selected < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (selected + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
      input.setAttribute('aria-activedescendant', options[index].id);
    } else if (event.key === 'Enter' && selected >= 0) {
      event.preventDefault(); rememberResults(); window.location.assign(options[selected].href);
    }
  }
  document.addEventListener('focusout', event => {
    const form = event.target.closest?.(SEARCH_FORM);
    if (form && !form.contains(event.relatedTarget)) cancelSuggestions(form.querySelector('[data-native-query]'));
  });
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest?.(SEARCH_FORM)) locate()?.querySelectorAll('[data-native-query]').forEach(cancelSuggestions);
  });
  // Keep the owned query input independent from the installed predictive-search handlers.
  // Default text editing, focus and form submission remain native browser behavior.
  ['focus', 'focusin', 'pointerdown', 'mousedown', 'touchstart', 'click', 'keydown', 'keyup', 'input'].forEach(type => {
    window.addEventListener(type, event => {
      if (!event.target.matches?.('[data-native-query]')) return;
      const form = event.target.closest(SEARCH_FORM);
      if (!form?.closest(ROOT)) return;
      if (type === 'input' && !event.isComposing) requestSuggestions(event.target);
      if (type === 'keydown' && !event.isComposing) suggestionKey(event.target, event);
      event.stopImmediatePropagation();
    }, true);
  });
  document.addEventListener('submit', event => {
    const searchForm = event.target.closest ? event.target.closest(SEARCH_FORM) : null;
    if (searchForm?.closest(ROOT)) {
      cancelSuggestions(searchForm.querySelector('[data-native-query]'));
      event.preventDefault();
      window.clearTimeout(debounceId);
      const target = urlForForm(searchForm.closest(ROOT).querySelector(FORM));
      target.pathname = new URL(searchForm.dataset.nativeSearchUrl || searchForm.action, window.location.href).pathname;
      const data = new FormData(searchForm);
      target.searchParams.set('q', String(data.get('q') ?? '').trim());
      target.searchParams.delete('leshems_query');
      navigate(normalizeSearchTarget(target, searchForm.closest(ROOT)), { closeDrawer: true, moveFocus: true });
      return;
    }
    const form = event.target.closest ? event.target.closest(FORM) : null;
    if (!form || !form.closest(ROOT)) return;
    event.preventDefault();
    window.clearTimeout(debounceId);
    navigate(urlForForm(form), { closeDrawer: true, moveFocus: true });
  });
  document.addEventListener('click', event => {
    const root = event.target.closest ? event.target.closest(ROOT) : null;
    if (!root) { locate()?.querySelectorAll('details[open]').forEach(group => { group.open = false; }); return; }
    const summary = event.target.closest('details.leshems-native-pilot__filter > summary');
    const moreSummary = event.target.closest('[data-native-more] > summary');
    if (moreSummary && window.matchMedia('(min-width:750px)').matches) {
      root.querySelectorAll('details.leshems-native-pilot__filter[open]').forEach(group => { group.open = false; });
    }
    if (summary && window.matchMedia('(min-width:750px)').matches) {
      const current = summary.closest('details');
      if (!current.closest('[data-native-more]')) {
        const more = root.querySelector('[data-native-more]');
        if (more) more.open = false;
      }
      root.querySelectorAll('details.leshems-native-pilot__filter[open]').forEach(other => {
        if (other !== current) other.open = false;
      });
    }
    if (event.target.closest('[data-native-drawer-open]')) { event.preventDefault(); setDrawer(true, true); return; }
    if (event.target.closest('[data-native-drawer-close]')) { event.preventDefault(); setDrawer(false, true); return; }
    const link = event.target.closest('a[data-native-navigation]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    window.clearTimeout(debounceId);
    if (link.hasAttribute('data-native-clear')) {
      const current = new URL(window.location.href);
      for (const key of [...current.searchParams.keys()]) if (key.startsWith('filter.')) current.searchParams.delete(key);
      current.searchParams.delete('page');
      const sortOptions = [...root.querySelectorAll('select[name="sort_by"] option')].map(option => option.value);
      if (!sortOptions.includes(current.searchParams.get('sort_by'))) current.searchParams.delete('sort_by');
      current.searchParams.delete('leshems_stone');
      current.searchParams.delete('leshems_query');
      if (root.dataset.nativeValidation === 'blocked' && searchIntent(current.searchParams.get('q'))) current.searchParams.set('q', '*');
      navigate(inheritPreview(current), { moveFocus: true });
      return;
    }
    navigate(inheritPreview(url), { append: link.hasAttribute('data-native-next'), moveFocus: link.hasAttribute('data-native-page') && !link.hasAttribute('data-native-next') });
  });
  document.addEventListener('keydown', event => {
    const root = locate();
    if (!root) return;
    if (event.key === 'Escape' && !root.classList.contains('leshems-native-drawer-open')) {
      const group = event.target.closest?.('details[open]') || root.querySelector('details[open]');
      if (group) { event.preventDefault(); group.open = false; group.querySelector('summary')?.focus({ preventScroll: true }); }
      return;
    }
    if (!root.classList.contains('leshems-native-drawer-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); setDrawer(false, true); return; }
    if (event.key !== 'Tab' || !mobile.matches) return;
    const panel = root.querySelector(FORM);
    if (!panel) return;
    const focusables = [...panel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),summary')]
      .filter(el => el.getClientRects().length);
    if (!focusables.length) return;
    if (event.shiftKey && document.activeElement === focusables[0]) {
      event.preventDefault(); focusables[focusables.length - 1].focus();
    } else if (!event.shiftKey && document.activeElement === focusables[focusables.length - 1]) {
      event.preventDefault(); focusables[0].focus();
    }
  });
  window.addEventListener('popstate', event => {
    if (!locate()) return;
    window.clearTimeout(debounceId);
    const saved = visitedResults.get(window.location.href);
    if (saved) {
      activeRequest?.abort(); activeRequest = null; requestSequence++;
      loadObserver?.disconnect(); setDrawer(false, false);
      const root = new DOMParser().parseFromString(saved.html, 'text/html').querySelector(ROOT);
      locate().replaceWith(root); updateBusy(root, false);
      root.dataset.nativeRequestState = 'restored';
      configureRoot(root, new URL(window.location.href));
      syncCategoryLinks(); syncLocalizationReturn();
      restoreScrollPosition(event.state?.scrollY ?? saved.scrollY);
      return;
    }
    navigate(new URL(window.location.href), { popstate: true }).then(() => restoreLoadedPages(event.state));
  });
  mobile.addEventListener('change', () => setDrawer(false, false));
  const initialRoot = locate();
  if (initialRoot) {
    const initial = new URL(window.location.href);
    const target = new URL(initial.href);
    const restored = restoreLocalizationSelections(target, initialRoot);
    const normalized = normalizeSearchTarget(normalizeLegacyTarget(target), initialRoot);
    configureRoot(initialRoot, initial);
    if (restored || normalized.href !== initial.href) {
      initialRoot.dataset.nativeValidation = 'pending';
      const warning = initialRoot.querySelector('[data-native-filter-unavailable]');
      if (warning) warning.hidden = true;
      initialRoot.querySelectorAll('.leshems-native-pilot__grid,.leshems-native-pilot__pagination,[data-native-result-count]').forEach(element => { element.hidden = true; });
    }
    if (restored || normalized.href !== initial.href) {
      initialRoot.dataset.nativeInitialRestore = 'pending';
      navigate(normalized, { replace: true }).then(() => restoreLoadedPages(initialHistory));
    }
  }
  syncCategoryLinks();
  syncLocalizationReturn();
  if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
  if (initialRoot?.dataset.nativeInitialRestore !== 'pending') {
    if (initialHistory?.loadedThrough) restoreLoadedPages(initialHistory);
    else { rememberResults(); observeNextPage(); }
  }
})();


